<template>
    <div class="view">
        <div class="viewInner">
            <div class="bannerArea">
                <swiper :options="swiperOption" ref="bannerSwiper">
                    <swiper-slide class="swiper-slide" v-for="(item, index) in bannerList" :key="index"
                        :data-index="index">
                        <div class="swiper-slide-item-bgm"
                            :style="{ 'background-image': 'url(' + item.image + ')', 'cursor': item.link != '' ? 'pointer' : 'default' }"
                            @click="bannerClick(item)"></div>
                    </swiper-slide>
                </swiper>
                <div class="swiper-paginations" slot="pagination"></div>
            </div>
            <div class="commonBoxArea courseArea" v-if="course_show">
                <div class="boxInner">
                    <div class="commonTitle">
                        <div class="commonTitle_l">
                            <div class="commonTitle_text">精选课程</div>
                            <div class="commonTitle_tag">Courses<div class="a"></div>
                            </div>

                        </div>
                        <div class="commonTitle_r" @click="moreHanlde('moreCourse')">更多<i
                                class="iconfont icon-zhankai-copy"></i></div>
                    </div>
                    <div class="courseList">
                        <ul>
                            <li v-for="(item, index) in courselist" :key="index" @click="goSubject(item)">
                                <div class="itemCover">
                                    <el-image :src="item.spacepic">
                                        <div slot="error" class="image-slot">
                                            <img :src="require('../../../../static/img/classDefault.png')" alt="">
                                        </div>
                                    </el-image>
                                    <div v-if="item.space_price > 0" class="price-flag">收费</div>
                                </div>
                                <div class="itemBottom">
                                    <div class="itemTitle">{{ item.spacename }}</div>
                                    <div class="itemData" v-if="false">
                                        <div class="dataBox">
                                            <div class="dataBoxs"><i
                                                    class="iconfont icon-changyongdizhiweihu"></i><span>章节：{{
                                                        item.chapter_count }}</span>
                                            </div>
                                            <div class="dataBoxs"><i class="iconfont icon-huabumulu"></i><span>小节：{{
                                                item.children_count }}</span>
                                            </div>
                                        </div>
                                        <div class="dataBox">
                                            <div class="dataBoxs"><i class="iconfont icon-icon-"></i><span>{{ item.unums
                                            }}人学习</span></div>
                                        </div>
                                    </div>
                                    <div class="itemDatas">
                                        <div class="itemDatas_l">
                                            <div class="dataBoxs"><span class="dataBoxsMark">{{ item.unums }}</span>人学习
                                            </div>
                                            <div class="dataBoxs">{{ item.children_count }}小节</div>
                                        </div>
                                        <div class="itemDatas_r"><el-button class="defaultBtn1">查看详细</el-button></div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="commonBoxArea classArea">
                <div class="boxInner">
                    <div class="commonTitle">
                        <div class="commonTitle_l">
                            <div class="commonTitle_text">实训</div>
                            <div class="commonTitle_tag classTag">Training<div class="a"></div>
                            </div>
                        </div>
                        <div class="commonTitle_r" @click="moreHanlde('moreClass')">更多<i
                                class="iconfont icon-zhankai-copy"></i></div>
                    </div>
                    <div class="classList">
                        <ul>
                            <li v-for="(item, index) in classlist" :key="index" @click="goClass(item)">
                                <div class="itemCover">
                                    <el-image :src="item.spacepic">
                                        <div slot="error" class="image-slot">
                                            <img :src="require('../../../../static/img/classDefault.png')" alt="">
                                        </div>
                                    </el-image>
                                    <div class="itemClassNum">课程数：{{ item.subnums }}</div>
                                    <div v-if="item.space_price > 0" class="price-flag">收费</div>
                                </div>
                                <div class="itemBottom">
                                    <div class="itemTitle">{{ item.spacename }}</div>
                                    <div class="itemTag">
                                        <div class="tagBox" v-for="(item1, index1) in item.labels" :key="index1">
                                            <div class="tagIcon">#</div>
                                            <div class="tagText">{{ item1 }}</div>
                                        </div>

                                    </div>
                                    <div class="itemMes">
                                        <div class="itemPerson">老师：{{ item.real_name }}</div>
                                        <div class="itemNum">
                                            <i class="iconfont icon-icon-"></i>
                                            <span>{{ item.unums }}人学习</span>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="commonBoxArea postArea">
                <div class="boxInner">
                    <div class="commonTitle">
                        <div class="commonTitle_l">
                            <div class="commonTitle_text">岗位</div>
                            <div class="commonTitle_tag postTag">Jobs<div class="a"></div>
                            </div>
                        </div>
                        <div class="commonTitle_r" @click="moreHanlde('morePost')">更多<i
                                class="iconfont icon-zhankai-copy"></i></div>
                    </div>
                    <div class="postList">
                        <ul>
                            <li v-for="(item, index) in joblist" :key="index" @click="goClass(item)">
                                <div class="itemCover">
                                    <el-image :src="item.spacepic">
                                        <div slot="error" class="image-slot">
                                            <img :src="require('../../../../static/img/classDefault.png')" alt="">
                                        </div>
                                    </el-image>
                                    <div v-if="item.space_price > 0" class="price-flag">收费</div>
                                </div>
                                <div class="itemRight">
                                    <div class="itemTitle">
                                        <div>{{ item.spacename }}</div>
                                    </div>
                                    <div class="itemTag">
                                        <div class="tagBox" v-for="(item1, index1) in item.labels" :key="index1">
                                            {{ item1 }}</div>
                                    </div>
                                    <div class="itemData">
                                        <div class="dataBox"><i class="iconfont icon-kecheng1"></i><span>课程：{{
                                            item.subnums }}</span>
                                        </div>
                                        <div class="dataBox"><i class="iconfont icon-icon-"></i><span>{{ item.unums
                                        }}人学习</span></div>
                                    </div>
                                    <div class="itemMes">
                                        <div class="itemPerson">
                                            <div class="personCover"><img :src="item.headimgurl" alt=""></div>
                                            <div class="personText">{{ item.real_name }}</div>
                                        </div>
                                        <div class="itemNum">
                                            <el-button class="defaultBtn1">查看详情</el-button>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <!-- <div class="exchangeArea">
                <div class="boxInner">
                    <div class="commonTitle">
                        <div class="commonTitle_l">
                            <div class="commonTitle_text">交流讨论</div>
                        </div>
                        <div class="commonTitle_r"></div>
                    </div>
                    <div class="exchangeList">
                        <ul>
                            <li v-for="(item,index) in bbsList" :key="index" @click="goDetail(item.bbsid)">
                                <div class="itemContent">
                                    <div class="itemTitle">{{item.title}}</div>
                                    <div class="itemPerson">
                                        <div class="coverBox">
                                            <img v-show="item.headimgurl" :src="item.headimgurl"  alt="">
                                            <div  v-show="!item.headimgurl" class="coverText">{{item.uname | unameFilter}}</div>
                                        </div>
                                        <div class="nameBox">{{item.uname}}</div>
                                    </div>
                                    <div class="itemContents">{{item.summary}}</div>
                                    <div class="coverImgs" v-if="item.thumbnail_all.length>0">
                                        <img v-for="(itema,indexa) in item.thumbnail_all" :key="indexa" :src="itema" alt="">
                                    </div>
                                    <div class="itemTool">
                                        <div class="itemTime">最近编辑于{{item.createtime}}</div>
                                        <div class="itemToolRight">
                                            <div class="toolITem"  @click.stop="bbsOperate(item,index,'like')" :class="{'active':item.my_like==1}"><i class="iconfont icon-xihuan1"></i><span>喜欢</span></div>
                                            <div class="toolITem"  @click.stop="bbsOperate(item,index,'collect')" :class="{'active':item.my_collect==1}"><i class="iconfont icon-shoucang"></i><span>收藏</span></div>
                                            <div class="toolITem"  :class="{'active':item.my_praise==1}" @click.stop="bbsOperate(item,index,'praise')"><i class="iconfont icon-dianzan1"></i><span>点赞</span></div>
                                            <div class="toolITem"  :class="{'active':item.my_praise==2}" @click.stop="bbsOperate(item,index,'down')"><i class="iconfont icon-dianzan1-copy1"></i><span>踩</span></div>
                                            <div class="toolITem" @click.stop="goDetail(item.bbsid)"><i class="iconfont icon-huifu"></i><span>评论（{{item.reply_num}}）</span></div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <NoData style="padding: 5vh 0;" v-if="noDataShower"></NoData>
                    </div>
                </div>
            </div> -->
            <div class="applyTeacherArea" v-if="false">
                <div class="applyTeacherAreaInner boxInner">
                    <div class="applyTeacherText">
                        <div class="applyTeacherTextA">申请成为教师</div>
                        <div class="applyTeacherTextB">智能题海，AI一键出卷、精准判分、智能评价，重塑学习体验，开启智能教育新时代！</div>
                    </div>
                    <div class="applyTeacherBtn">
                        <el-button class="mainBtn1" @click="dialogApplyTeacher = true">申请成为教师</el-button>
                    </div>
                </div>
            </div>
            <!-- 入驻区域 -->
            <div class="settledArea">
                <div class="settled-title">
                    海量优质课程，满足各个岗位和场景的学习
                </div>
                <el-button class="mainBtn1" size="small" @click="goSettledPage()">机构入驻</el-button>
            </div>
            <!-- <div class="footerArea">
                <div class="footerAreaInner boxInner">
                    <div class="footerLeft">
                        <div class="footerLeft_t">联系我们</div>
                        <div class="footerLeft_b">contact us</div>
                    </div>
                    <div class="footerRight">
                        <div class="footerRight_item">
                            <div class="iconBox"><i class="iconfont icon-telephone"></i></div>
                            <div class="footerRight_content">电话：010-82894771</div>
                        </div>
                        <div class="footerRight_item">
                            <div class="iconBox"><i class="iconfont icon-dizhi-4-copy"></i></div>
                            <div class="footerRight_content">地址：北京市海淀区上地信息路2号中关村国际孵化园D座309</div>
                        </div>
                        <div class="footerRight_item">
                            <div class="iconBox"><i class="iconfont icon-youxiang1"></i></div>
                            <div class="footerRight_content">邮箱：service@ipieuvre.com</div>
                        </div>
                    </div>
                </div>
            </div> -->
            <!-- <div class="copyRightArea">
                <div class="boxInner">
                    <div class="itemBox">Copyright © <a href="https://www.youxuanit.com/"  target="_blank">优选创新（北京）科技有限公司</a>&nbsp;&nbsp;&nbsp;<a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">备案号：京ICP备15028437号</a> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo"><img :src="require('../../../../static/img/beian.png')" alt="">京公网安备  11010802032912号</a></div>
                </div>
            </div> -->
            <el-dialog :title="'申请成为教师'" width="600px" :visible.sync="dialogApplyTeacher" v-if="dialogApplyTeacher"
                custom-class="dialogBoxA dialogUlClass centerClass" class="dialogcomPaddingtBox " center
                :close-on-click-modal="false">
                <applyTeacher v-if="dialogApplyTeacher" ref="dialogApplyTeacher" @statusEmit="statusEmit">
                </applyTeacher>
                <span slot="footer" class="dialog-footer">
                    <el-button type="default" class=" saveBtn" @click="dialogApplyTeacher = false">取消</el-button>
                    <el-button type="primary" class=" saveBtn" :class="{ 'disBtn': btnStatus == 0 || btnStatus == 1 }"
                        :disabled="btnStatus == 0 || btnStatus == 1" @click="applyTeacherHandle"
                        v-preventReClick="2000">确定</el-button>
                </span>
            </el-dialog>
        </div>
        <div class="advertisement" v-if="advertisementShow">
            <div class="advertisement-inner">
                <!-- <img src="../../../../static/img/home/linghui_ad.png" alt=""> -->
                <img :src="advertisementData.ad_image" alt="" @click="openWindow()">
                <i class="el-icon-circle-close" @click="closeAdvertisement()"></i>
            </div>
        </div>
    </div>
</template>
<script>
import { postAjax } from '@/api/index.js';
import NoData from '@/components/NoData/noData.vue';
import applyTeacher from '@/page/Public/ClassManagement/Students/dialog/applyTeacher.vue';
export default {
    data() {
        return {
            course_show: false,
            dialogApplyTeacher: false,
            btnStatus: '',
            bbsList: [],
            bannerList: [],
            courselist: [],
            classlist: [],
            joblist: [],
            noDataShower: false,
            swiperOption1: {
                watchOverflow: true,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true,
                },
                autoplay: {
                    delay: 10000,
                    disableOnInteraction: false,
                },
                // on:{
                //     click: (e)=> {
                //         let tbbsm=e.target.getAttribute('data-index') // 获取自定义属性
                //         this.bannerClick(this.bannerList[tbbsm])
                //     },

                // },
                pagination: {
                    el: '.swiper-paginations',
                    clickable: true,
                }

            },
            swiperOption2: {
                effect: 'fade',
                fadeEffect: {
                    crossFade: true,
                },
                loop: true,
                autoplay: {
                    delay: 10000,
                    disableOnInteraction: false,
                },
                // on:{
                //     click: (e)=> {
                //         let tbbsm=e.target.getAttribute('data-index') // 获取自定义属性
                //         this.bannerClick(this.bannerList[tbbsm])
                //     },

                // },
                pagination: {
                    el: '.swiper-paginations',
                    clickable: true,
                }

            },
            advertisementData: {},
            advertisementShow: false
        }
    },
    computed: {
        swiperOption() {
            var len = this.bannerList.length;
            if (len <= 0) {
                return
            }

            if (len == 1) {
                return this.swiperOption1;
            } else {
                return this.swiperOption2;
            }
        }
    },
    created() {
        this.homepage();
        // 获取讨论列表
        // this.getBbsList();
        // 获取广告
        this.getAdvertisement();
    },
    mounted() {
    },
    components: {
        NoData, applyTeacher
    },
    methods: {
        // openLink(link){
        //     if(link){
        //         window.open(link,'_blank');
        //     }
        // },
        getAdvertisement() {
            postAjax('/index/home/get_ad').then(res => {
                if (res.code === 1) {
                    if(res.data.ad_image){
                        this.advertisementData = res.data;
                        this.advertisementShow = sessionStorage.getItem('hideAdvertisement') ? false : true;
                    }
                }
            });
        },
        closeAdvertisement() {
            this.advertisementShow = false;
            sessionStorage.setItem('hideAdvertisement', 'true');
        },
        goSubject(item) {
            this.$router.push({
                path: `/index/courseDetail/1/${item.spaceid}/${item.spaceid}`
            });
        },
        homepage() {
            postAjax("/school/homepage").then((res) => {
                if (res.code == 1) {
                    this.bannerList = res.data.banner;
                    this.courselist = res.data.course.items;
                    if (res.data.course.count > 0) this.course_show = true;
                    this.classlist = res.data.class.items || [];
                    this.joblist = res.data.job.items ? res.data.job.items : [];
                    this.$nextTick(() => {
                        this.$refs.bannerSwiper.destroySwiper();
                    })
                    this.$nextTick(() => {
                        this.$refs.bannerSwiper.initSwiper();
                    })
                }
            });
        },

        goDetail(bbsid) {
            let role = localStorage.getItem("utype") || 1;
            let paths = 'index';
            const { href } = this.$router.resolve({ path: `/${paths}/exchangeDetail/${bbsid}` });
            window.open(href, '_blank');
        },
        bbsOperate(item, ind, optype) {
            postAjax("/bbs/bbsOperate", { type: 'discuss', bbsid: item.bbsid, optype: optype }).then((res) => {
                if (res.code == 1) {
                    this.bbsList[ind].praise_num = res.data.praise_num;
                    this.bbsList[ind].down_num = res.data.down_num;
                    // this.bbsList[ind].like_num = res.data.like_num;
                    // this.bbsList[ind].collect_num = res.data.collect_num;
                    this.bbsList[ind].my_praise = res.data.my_praise;
                    this.bbsList[ind].my_like = res.data.my_like;
                    this.bbsList[ind].my_collect = res.data.my_collect;
                }
            });
        },
        statusEmit() {
            this.btnStatus = data;
        },
        getBbsList() {
            let params = {
                category: 0,
                source_resid: 0,
                isself: 0,
                title: '',
                page: 1,
                size: 10,
                order: 'createtime',

            }
            postAjax("/bbs/bbsList", params).then(res => {

                this.bbsList = res.data.items;
                this.count = res.data.count;
                if (this.bbsList.length > 0) {
                    this.noDataShower = false;
                } else {
                    this.noDataShower = true;
                }
            })
        },
        applyTeacherHandle() {
            this.$refs.dialogApplyTeacher.submitHandle();
        },
        moreHanlde(pathName) {
            this.$router.push({
                path: `/index/moreList/${pathName}`
            });
        },
        bannerClick(item) {
            this.goPageByURI(item.linkstyle,item.link);
            return;
        },

        openWindow(){
            this.closeAdvertisement()
            this.goPageByURI(this.advertisementData.linkstyle,this.advertisementData.ad_link);
            return;
        },
        goPageByURI(style,link){
            if (link == '') return;
            if (/http./g.test(link)) {
                if (style == 2){
                    window.open(link, '_blank');
                }else{
                    window.location.href = link;
                }
            } else {
                if (style == 2){
                    let routeUrl = this.$router.resolve({ path: link });
                    window.open(routeUrl.href, '_blank');
                }else{
                    this.$router.push({path: link})
                }

            }
        },

        goClass(item) {
            this.$router.push({
                path: `/index/classDetail/${item.spaceid}`
            })
        },
        goSettledPage() {
            this.$router.push({
                path: '/index/settled'
            });
        }
    },
    filters: {
        unameFilter(val) {
            return val ? val.substring(val.length - 2) : val;
        }
    }
}
</script>
<style lang="scss" scoped>
@import "~@/assets/css/homepage/homes/home.scss";
</style>



// WEBPACK FOOTER //
// src/page/Public/Home/home.vue